/**
 * Bir Blob'u tarayıcıya indirtir.
 *
 * Üç çağrı yeri aynı beş satırı kendi eliyle yazıyordu (şablon indirme, mağaza kapsamlı eşleme
 * şablonu, iş sonucu raporu). Beş satırın kendisi önemsiz; unutulabilir olan `revokeObjectURL`:
 * atlandığında blob, sekme kapanana kadar bellekte tutulur ve büyük bir CSV'yi arka arkaya indiren
 * bir kullanıcı bunu sızıntı olarak biriktirir. Tek yerde olması, o satırın bir daha atlanmamasını
 * sağlar.
 */
export function saveBlobAs(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    window.URL.revokeObjectURL(url);
  }
}
